import { Navigate, useSearchParams } from 'react-router-dom';
import { ReactNode, useEffect, useRef } from 'react';
import { useAuthProvider } from '../../../providers/AuthProvider';
import AppLoader from '../AppLoader/AppLoader';

interface Props {
  children: ReactNode;
}

const ProtectedRoute = ({children}: Props) => {
  const authContext = useAuthProvider();
  const hasFetchedUser = useRef(false);
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (!hasFetchedUser.current) {
      authContext.getUser();
      hasFetchedUser.current = true;
    }
  }, [authContext]);

  useEffect(() => {
    const encryptedString = searchParams.get('data');
    if (encryptedString){
      sessionStorage.setItem('OBXData', encryptedString);
    }
  }, [searchParams]);

  return (
    <>
      {
        authContext.loading ? <AppLoader /> :
        authContext.user.accessToken ? children : 
        <Navigate to="/login" />
      }
    </>
  );
};

export default ProtectedRoute;